import {Component, computed} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {FormGroup, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {toSignal} from '@angular/core/rxjs-interop';
import {ProjectStepSaveButtonComponent} from '../../../../../../../shared/project-step-save-button/project-step-save-button.component';
import {FormControlsConfig} from '../components/abstract-form-directive';
import {NgClass} from '@angular/common';
import {
  ImplementationTimelineContainerData,
  ImplementationTimelineData,
} from './implementation-timeline-container.types';
import {PanelHeaderComponent} from '../../../../../../../shared/components/header/panel-header/panel-header.component';
import {Panel} from 'primeng/panel';
import {TableModule} from 'primeng/table';
import {TranslateDirectusPipe} from '@frontend/transloco';
import {DirectusTranslation, ModuleFunction} from '@frontend/directus';
import {AbstractFormArrayDirective} from '../components/abstract-form-array-directive';
import {FormFieldDatepickerComponent} from '../../../../../../../shared/components/inputs/form-field/form-field-datepicker/form-field-datepicker.component';
import {PlannedAction} from '@frontend/shared';

@Component({
  selector: 'app-contract-implementation-timeline',
  imports: [
    FormsModule,
    ProjectStepSaveButtonComponent,
    ReactiveFormsModule,
    PanelHeaderComponent,
    Panel,
    TableModule,
    TranslocoPipe,
    NgClass,
    TranslateDirectusPipe,
    FormFieldDatepickerComponent,
  ],
  templateUrl: './contract-implementation-timeline.component.html',
})
export class ContractImplementationTimelineComponent extends AbstractFormArrayDirective<
  ImplementationTimelineContainerData,
  ImplementationTimelineData
> {
  private static readonly FORM_ARRAY_CONTROLS: FormControlsConfig<ImplementationTimelineContainerData> =
    {
      data: [[]],
    };

  // ---- signals -------
  readonly moduleFunctions = toSignal(this.directusService.loadModuleFunctions(), {
    initialValue: [] as ModuleFunction[],
  });

  constructor() {
    super(ContractImplementationTimelineComponent.FORM_ARRAY_CONTROLS);
  }

  protected createRowFormGroup(item: ImplementationTimelineData): FormGroup {
    return this.fb.group({
      directusModuleFunctionId: [item.directusModuleFunctionId],
      officesLookupResponse: [item.officesLookupResponse],
      plannedAction: [item.plannedAction],
      goLiveDate: [item.goLiveDate],
      contractExpiryDate: [item.contractExpiryDate],
    });
  }

  readonly implementationConfigRows = computed<IntegrationConfigRowVM[]>(() => {
    const config = this.inputObject();
    const modules = this.moduleFunctions();

    if (!config?.data?.length) return [];

    return config.data.map((item) => {
      const functionTranslations = modules.find(
        (x) => x.id === item.directusModuleFunctionId,
      )?.translations;

      return {
        data: item,
        functionTranslations,
      } as IntegrationConfigRowVM;
    });
  });

  protected isReplaceSystem(plannedAction: PlannedAction) {
    return plannedAction === PlannedAction.REPLACE;
  }

  protected extractTranslationKey(plannedAction: PlannedAction): string {
    const prefix = 'project.steps.systemRecording.plannedAction.';
    if (this.isNoSystem(plannedAction)) {
      return prefix + 'noSystem';
    }
    return prefix + plannedAction.toLowerCase();
  }

  private isNoSystem(plannedAction: PlannedAction) {
    return plannedAction === PlannedAction.NO_SYSTEM;
  }
}

interface IntegrationConfigRowVM {
  data: ImplementationTimelineData;
  functionTranslations?: DirectusTranslation[];
}
